import { render } from "./Login.vue?vue&type=template&id=8180667c&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=8180667c&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8180667c"]])

export default __exports__